"use client"

import React, {useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import {Divider} from "@mantine/core";
import PrivatePolicyTwContent from "@/app/(index)/privacy-policy/tw-content";
import PrivatePolicyEnContent from "@/app/(index)/privacy-policy/en-content";
import {useMediaQuery} from "@mantine/hooks";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

export default function Page() {
    const { fontSize, lang } = useGlobalStateStore();
    const [tab, setTab] = useState<number>(1);
    const loadCurrentFontSize = (s: number, m: number, l: number) => {
        if(fontSize == 0) return `text-[${s}px]`;
        else if(fontSize == 1) return `text-[${m}px]`;
        else if(fontSize == 2) return `text-[${l}px]`;
    }

    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <Bread name_c="隱私保護及網站安全政策" name_e="Privacy Protection and Website Security Policy"/>
                    )
                }
                <div
                    className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] text-[#5b5b5b] text-[35px] font-bold">
                        {lang == "tw" && "隱私保護及網站安全政策"}
                        {lang == "en" && "Privacy Protection and Website Security Policy"}
                    </div>


                    {
                        lang == "tw" && (
                            <div className="mt-[40px]">
                                <div
                                    className={cx("text-[#8d7f4c] font-bold", mediaQueryLessSM ? 'text-[46px]' : 'text-[26px]')}>
                                    財團法人國家實驗研究院科技政策研究與資訊中心隱私保護及網站安全政策
                                </div>
                            </div>
                        )
                    }

                    <Divider mt={30} my={35}/>

                    {lang == "tw" && <PrivatePolicyTwContent/>}
                    {lang == "en" && <PrivatePolicyEnContent/>}
                </div>
            </div>
            <Footer/>
        </div>
    );
}
